export default __webpack_public_path__ + "34bae1afae90022f9f63d521e16da626.svg";